import Button from "@common/components/Button";
import { ArrowLeftIcon } from "@common/components/icons";
import { useTranslation } from "next-i18next";

type Props = {
  onClick?: () => void;
};

const BackButton = ({ onClick = () => null }: Props) => {
  const { t } = useTranslation(["profile"]);

  return (
    <Button
      buttonStyle="primary"
      size="large"
      spacing="fixed"
      fill="link"
      className="lg:hidden"
      leftIcon={
        <ArrowLeftIcon className="text-primary-bright h-6 w-6 inline-block align-middle" />
      }
      onClick={onClick}
    >
      {t("profile:my_account")}
    </Button>
  );
};

export default BackButton;
